import {StatutTrajetEnum} from '../../gestion-navette/onglets-gestion-navette/trajets/model/statut-trajet.enum';

/**
 * DTO pour représenter un trajet dans l'application de gestion de navette.
 */
export class TrajetDto {
	id?: number;
	nombrePlaces: number;
	nomLieuDepart: string;
	adresseDepart: string;
	dateDepart: number;
	nomLieuArrivee: string;
	adresseArrivee: string;
	dateArrivee: number;
	information?: string;
	nombreReservations: number;
	statut?: StatutTrajetEnum;

	// L'id de la reservation de l'utilisateur connecté pour ce trajet. Uniquement utilisé dans la partie réservation
	reservationId?: number;

	constructor(partial?: Partial<TrajetDto>) {
		if (partial) {
			Object.assign(this, partial);
		}
	}
}